import React from 'react';
import Image from '@/components/AppImage/AppImage';
import logoIcon from '../../assets/logo.svg';
import './Spinner.css';

const Spinner: React.FC = () => {
    return (
        <div
            style={{
                position: 'fixed',
                inset: '0',
                background: 'linear-gradient(135deg, #F1F1F4 0%, #FFFFFF 50%, #E1E1E7 100%)', // replaced very-light-gray, white, lighter-gray
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '24px', // var(--spacing-l)
                minHeight: '100vh',
                zIndex: 9999
            }}
        >
            {/* Logo */}
            {/* <Image
                src="/images/banner_logo.png"
                alt="Globe Thrivers"
                onClick={() => router.push('/')}
                style={{
                    marginBottom: '0px', // var(--spacing-xl)
                    cursor: 'pointer',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                    objectFit: 'contain'
                }}
                width={250}
                height={200}
            /> */}

            <Image
                src={logoIcon}
                alt="Logo"
                width={200}
                height={100}
                style={{
                    marginBottom: '0px',
                    cursor: 'pointer',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                    objectFit: 'contain'
                }}
                // onClick={() => router.push('/')}
            />
            {/* Loading Animation */}
            <div style={{ position: 'relative', marginBottom: '24px' }}>
                <div
                    style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        background: '#FFFFFF', // color-surface
                        border: '1px solid #E1E1E7', // color-card-border
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                    }}
                >
                    <div
                        style={{
                            width: '32px',
                            height: '32px',
                            border: '3px solid #E1E1E7', // lighter-gray
                            borderTop: '3px solid #FF5212', // color-primary (orange)
                            borderRadius: '50%',
                            animation: 'globethrivers-spinner-spin 1s linear infinite'
                        }}
                    />
                </div>

                {/* Pulsing rings */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-10px',
                        left: '-10px',
                        width: '100px',
                        height: '100px',
                        borderRadius: '50%',
                        border: '2px solid rgba(0, 0, 0, 0.08)', // darker to make visible
                        animation: 'globethrivers-spinner-pulse 2s ease-in-out infinite'
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '-20px',
                        left: '-20px',
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        border: '1px solid rgba(0, 0, 0, 0.05)', // lighter outer ring
                        animation: 'globethrivers-spinner-pulse 2s ease-in-out infinite 0.5s'
                    }}
                />
            </div>
        </div>
    );
};

export default Spinner;
